export class FetchError extends Error {
  constructor(status, message, body, ...params) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, FetchError);
    }

    this.name = "FetchError";
    // Custom debugging information
    this.status = status;
    this.message = message;
    this.body = body;
  }
}

export class RequestError extends Error {
  constructor(code, message, body, ...params) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, RequestError);
    }

    this.name = "RequestError";
    // Custom debugging information
    this.code = code;
    this.message = message;
    this.body = body;
  }
}
